import { styled } from '@linaria/react';

export const RelatedWrapper = styled.div`
  height: inherit;
  display: block;
`;
